/* mixins/snackbar */
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'getSnackbarMessage',
            'getSnackbarShow'
        ])
    },

    methods: {
        ...mapActions([
            'setSnackbarMessage',
            'setSnackbarShow'
        ]),

        showSnackbar(message) {
            this.setSnackbarMessage(message)
            this.setSnackbarShow(true)
        }
    }
}